import { useState, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import Button from '@mui/material/Button';
import { Grid, Box } from '@mui/material';
import { addDays, format } from 'date-fns';
import { facilityData } from '../Store';
import { useAuth } from '../contexts/AuthContext';
import DateOutlinedInput from './input/DateOutlinedInput';
import CustomSnackBar from '../components/alert/CustomSnackBar';

const Header = (props) => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - prpos
	//-----------------------------------------------
    const { loginInfo, backButton, backPage, setEntryDate } = props

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ openSnackBarTrue, setOpenSnackBarTrue ] = useState(false);

	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo, setAuthInfo }  = useAuth()
    const userName      = authInfo.userName
    const authorityName = authInfo.authorityName
    const targetDate = authInfo.targetDate
    
    const navigate = useNavigate()
    const location = useLocation();
    const today    = format(addDays(new Date(), 0), 'yyyy-MM-dd')

	//-----------------------------------------------
	// Cookieに保存したデータを削除する
	//-----------------------------------------------
    const CookieDataDelete = () => {
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('facilityCode');
        sessionStorage.removeItem('facilityName');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('userNameDsp');
        sessionStorage.removeItem('authority');
        sessionStorage.removeItem('traderCode');
        sessionStorage.removeItem('trader');
    }
	//-----------------------------------------------
	// 入力日を変更する
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        if (backPage != '/bidGroup') {
            setAuthInfo(prevState => ({
                ...prevState,
                packingProcess : true,
                targetDate      : value,
            }))
            setEntryDate(value);
        }
    }
	//-----------------------------------------------
	// 戻るボタンのクリック
	//-----------------------------------------------
    const handleClick_back = () => {
        const pathName = location.pathname;
        if (pathName === '/bidPreRegister') {
            handleClickSnackBarTrue();
        } else {
            backPage == 'prev' ? navigate(-1) : navigate(backPage);
        }
    }
    //===============================================
    // useEffect
    //===============================================
    useEffect(() => {
        document.body.classList.remove("port");
        document.body.classList.remove("hygiene");
    }, []);
	//===============================================
	// UI Message
	//===============================================
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true); }
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false);
    };
    //===============================================
    // CSS
    //===============================================
    const header = {
        width          : '100%',
        height         : '50px',
        maxHeight      : '160px',
        display        : 'flex',
        justifyContent : 'space-between',
        alignItems     : 'center'
    }
    const header_pageTitle = {
        color      : '#305496',
        fontSize   : '1.5rem',
        fontWeight : '1000',
        marginLeft : '1rem',
        marginRight : '1rem',
        fontWeight : 'bold'
    }
    const header_flex = {
        display    : 'flex',
        marginLeft : '20px',
        width:'300px'
    }
    const header_userInfo = {
        fontSize   : '1.0rem',
        fontWeight : '1000',
        padding    : '7px',
        textAlign  : 'left',
    }
    //===============================================
	// JSXのレンダー
    //===============================================
    return (
        <>
            <header style={ header } className='no-print'>
                <Box display="flex" justifyContent="space-between" sx={{mt:1}}>
                    <div style={ header_flex }>
                        <img src={`${process.env.PUBLIC_URL}${ facilityData.logoUrl }`} style={{height:'40px', width:'50px'}} />  
                        <a href="#" className="pagetitle" style={ header_pageTitle }>{ facilityData.facilityName }</a>
                    </div>
                    <div style={{display:'flex', width:'320px'}}>
                        <div style={ header_userInfo }>
                            {loginInfo == 'on'
                                ?
                                `ログイン：${ userName }(${ authorityName })`
                                : <></>
                            }
                        </div>
                    </div>
                    <div style={{display:'flex', width:'120px'}}>
                        <div>
                            {loginInfo == 'on'
                            ? 
                            <div>
                                <DateOutlinedInput 
                                    id       = "unloadList_targetDate"
                                    value    = { targetDate }
                                    width    = '150px'
                                    onChange = { (e) => handleChange_entryDate(e.target.value) } 
                                />
                            </div>
                            : <></>
                            }
                        </div>
                    </div>
                    <div style={{display:'flex', width:'110px'}}>
                        {backButton == 'on'
                            ? 
                            <Button
                                variant="contained"
                                style={{color:'#fff', marginLeft:'40px'}}
                                onClick={() => handleClick_back() }
                                >
                                戻る
                            </Button>
                            : <></>
                        }
                    </div>
                    <div style={{display:'flex', width:'120px'}}>
                        {loginInfo == 'on'
                        ? 
                            <Button
                                variant="contained"
                                style={{color:'#fff', marginLeft:'10px'}}
                                onClick={() => {
                                    CookieDataDelete()
                                    navigate('/')
                                }}
                                >
                                ログアウト
                            </Button>
                        : <></>
                        }
                    </div>
                </Box>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "確定売りの入力中です。「取り消し」ボタンで取り消しを行ってください"
                />
            </header>
        </>
    );
}

export default Header